import { Component } from "../../core/Component";

export class HoldPositionComponent extends Component {}
